import { useState } from "react";
import { LinearProgress, Tabs } from '../../tailwindcomponents';
import { HandoverReportList } from '../../components/Handover';
import { useQueryTab } from '../../utils/usePersistedTab';
import { maintenanceControlHandoverConfig } from './maintenanceControlHandoverConfig';

const MaintenanceControl = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const { tabValue, setTabValue } = useQueryTab("tab", 0);

  return (
    <div>
      {loading && <LinearProgress />}
      <Tabs
        tabNames={["Handover Report"]}
        onChangeTabValue={(tabValue: number) => setTabValue(tabValue)}
        tabValue={tabValue}
      />
      {tabValue === 0 && <HandoverReportList config={maintenanceControlHandoverConfig} setLoading={setLoading} />}
    </div>
  )
}
export default MaintenanceControl;
